import { EditUserInDto, EditUserOutDto, UserInDto } from '../../../types/user.dto'

export const EDIT_USER = 'EDIT_USER'
export const EDIT_USER_ERROR = 'EDIT_USER_ERROR'
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const RESET_EDIT_USER = 'RESET_EDIT_USER'

export interface EditUser {
  type: typeof EDIT_USER
  payload: EditUserOutDto
}

export interface EditUserSuccess {
  type: typeof EDIT_USER_SUCCESS
  payload: EditUserInDto
}

export interface EditUserError {
  type: typeof EDIT_USER_ERROR
  payload: boolean | string
}

export interface ResetEditUser {
  type: typeof RESET_EDIT_USER
  payload: null
}

export interface State {
  data: UserInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditUser | EditUserSuccess | EditUserError | ResetEditUser
